import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ClaimDetailsStateService } from "@modules/core/state";
import { AppState } from "@modules/feature/models/core/app-state.interface";
import { Feature } from "@modules/feature/models/feature";
import { Store, select } from "@ngrx/store";
import { Observable, Subject, filter, map, takeUntil } from "rxjs";
import { FeatureListForm } from "../../models/feature/feature-list";
import { listActions } from "../../state/actions";
import { listSelectors, spinnerSelectors } from "../../state/selectors";

@Component({
  selector: "cla-feature-claim",
  templateUrl: "./feature-claim.component.html",
  styleUrls: ["./feature-claim.component.scss"],
  standalone: false,
})
export class FeatureClaimComponent
  implements OnInit, OnDestroy, AfterContentChecked
{
  isLoading$: Observable<boolean>;
  claimNumber$: Observable<any>;
  features$: Observable<FeatureListForm[] | null | Feature[]>;
  claimNumber = "";

  private unsubscribeSubject$: Subject<void> = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private store$: Store<AppState>,
    private changeDetectorRef: ChangeDetectorRef,
    private claimDetailsStateService: ClaimDetailsStateService
  ) {}

  ngOnInit(): void {
    this.init();
    this.claimDetailsStateService.onSetPageScrollingEnabled(false);
  }

  ngOnDestroy(): void {
    this.unsubscribeSubject$.next();
    this.unsubscribeSubject$.complete();
    this.store$.dispatch(listActions.clearReq());
    this.claimDetailsStateService.onSetPageScrollingEnabled(true);
  }

  ngAfterContentChecked() {
    this.changeDetectorRef.detectChanges();
  }

  private init() {
    this.isLoading$ = this.store$.pipe(
      select(spinnerSelectors.selectIsSpinnerActive)
    );

    this.claimNumber$ = this.route.params.pipe(
      filter(
        (params) =>
          params["claimNumber"] !== undefined && params["claimNumber"] !== ""
      ),
      map((params) => params["claimNumber"])
    );

    this.claimNumber$
      .pipe(takeUntil(this.unsubscribeSubject$))
      .subscribe((claimNumber) => {
        this.claimNumber = claimNumber;
        this.store$.dispatch(
          listActions.getClaimFeaturesWithPreReq({ claimNumber })
        );
      });

    this.features$ = this.store$.pipe(select(listSelectors.selectFeatures));
  }
}
